const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const normalizeNotificationEmailList = (value) => {
  if (!value || value.trim() === '') return undefined;
  return value
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .join(',');
};

const validateNotificationEmailList = (value) => {
  if (!value || value.trim() === '') return null;

  const parts = value.split(',').map((s) => s.trim());

  if (parts.some((p) => !p)) {
    return 'Email addresses must not be empty';
  }

  const normalized = parts.join(',');
  if (normalized.length > 255) {
    return 'Notification email must be at most 255 characters';
  }

  for (const email of parts) {
    if (!EMAIL_REGEX.test(email)) {
      return `"${email}" is not a valid email address`;
    }
  }

  return null;
};

export { normalizeNotificationEmailList, validateNotificationEmailList };
